import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<main>\n  <SqLoading @isActive={{true}} />\n</main>",{ moduleName: "@banking/savings-onboarding-app/templates/loading.hbs" })